module.exports = __webpack_public_path__ + "static/media/u46.ca2a4102.svg";